module.exports = __webpack_public_path__ + "img/Cryptocurrency.8ba90ef4.webp";